<template>
	<div style="padding:8px 10px 0;" v-loading="loading">
		<div class="tips">
			<span>请选择历史批次：</span>
			<el-select v-model="batchName" :filterable="true" @change="selectBatchInfo" style="width: 200px;margin: 0 10px;" placeholder="请选择">
        <el-option v-for="item in batchInfoList" :key="item.id" :label="item.batchName" :value="item.id">
        </el-option>
			</el-select>
			<span v-if="isShow">该批次的薪资所属月份为{{batchInfo.wageMonth}}，社保月份为{{batchInfo.socMonth}}，税金所属月份为{{batchInfo.taxMonth}}，可点击</span>
			<el-link v-if="isShow" type="primary" style="margin-left:4px;" @click="getDetailMessage(formInline,batchInfo,'true')">查看详细信息</el-link>
		</div>
		<p class="p1" style="margin-bottom:8px;">已选表头展示：</p>
		<vxe-grid auto-resize sync-resize header-align="center" column-min-width="100px" 	:optimization="{scrollX: {gt: 400}}"
		 :data.sync="list" ref="accountTable"  :columns="tableColumn">
      <template v-slot:empty v-if="tableColumn && tableColumn.length>0">
			<span>
				<p style="text-align: center;">已全部匹配</p>
			</span>
      </template>

		</vxe-grid>
		<div class="div1" style="height:36px;">
			<span class="p1">选择要复制的表头：</span>
			<div class="flex">
				<searchBox :dynamicColumn.sync="dynamicColumn"></searchBox>
				<div style="display:flex;align-items: center;">
					<el-radio-group v-model="radio" @change="changList">
						<el-radio label="1">选择全部项</el-radio>
						<el-radio label="2">清除项目</el-radio>
					</el-radio-group>
				</div>
			</div>
		</div>
		<div class="div1 seachBox">
			<div v-for="(column,i) in dynamicColumn" :key="i">
				<span class="label">{{column.title}}</span>：
				<searchInput :values.sync="column.grounpColumns" :lists="column.dataList" @click="changeIndex(i)" :class="{'show':showIndex==i}"></searchInput>
			</div>
		</div>
		<div class="footer">
			<div>温馨提示：</div>
			<div>
        <p>1.首次使用时，已选表头区默认显示雇员姓名、证件号码；非首次使用则显示最近一次设置的复制列。</p>

        <p>2.仅导入项可被选择复制，引用项及计算项都不可被选择复制。</p>

        <p>3.如需查看所选批次的所有列头被选择的情况，可表头点击筛选框。</p>

        <p>4.可通过点击选择区除雇员姓名、证件号码外的列头，来控制复制或者不复制某列。雇员姓名、证件号码默认为选中状态，无法取消选择。</p>
			</div>
		</div>
		<div style="margin-top: 38px;padding-bottom: 24px;text-align:center;">
			<el-button type="primary" @click="save()">保存</el-button>
		</div>

		 <el-dialog
			ref=""
			id="dialog1"
			width="850px"
			v-dialogDrag
			:close-on-click-modal="false"
			:close-on-press-escape="false"
			title="温馨提示"
			:visible.sync="dialogheaderVisible"
			>
				<reminder :reminderList.sync="reminderList"></reminder>
			</el-dialog>

	</div>

</template>

<script>
	import bspTable from "@/components/bsp/bsp-table/bsp-table";
	import bspTableColumn from "@/components/bsp/bsp-table-column/bsp-table-column";
	import searchInput from "@/views/wage/dataReadyTemplate/dataImport/template/searchInput.vue";
	import searchBox from "@/views/wage/dataReadyTemplate/dataImport/template/searchBox.vue";
	import reminder from "@/wage-components/bsp-reminder/bsp-reminder.vue";
	import {getBatchInfoByGroupId} from "@/api/wage/batchTemplate";
  import {commonConst} from "@/const/code"
	import {
		queryWageItems,
		queryOldTemplateHeader,
		queryWageBatchList,
		saveHisBatchData,

	} from "@/api/demo/demo"
	export default {
		name: "dataHistory",
    props:{
      formInline: {
        type: Object,
        default: {},
      },
      batchInfoDetail: {
        type: Object,
        default: {},
      },
      /*serverGroupList: {
        type: Object,
        default: {},
      },
      contentServerGroup: {
        type: String,
        default: '',
      },*/
    },
		components: {
			bspTableColumn,
			bspTable,
			searchInput,
			searchBox,
			reminder
		},
		data() {
			return {
        loading:false,
        isShow:false,
				radio: '',
				showIndex: 0,
				dialogheaderVisible:false,
				listQuery: {
					limit: 20,
					page: 1,
					total: 0,
				},
				list: [],
				reminderList:{
					title:'当前正在进行薪资计算，计算完成后将生成发薪和报税数据，请稍后…',
					list:['数据准备','薪资计算','生成发薪报税数据','发薪','报税','查看结果'],
					current:1
				},
				dynamicColumn: [],
				tableColumn: [],
        batchInfoList:[],//历史批次信息集合
        batchInfo:{
          batchName:'',//所选历史批次名称
          wageMonth:'',//所选历史批次工资月份
          socMonth:'',//所选历史批次社保月份
          taxMonth:'',//所选历史批次税金月份
        },
        batchName:'',
			};
		},
		created() {
		  //查询历史批次:
      this._getBatchInfoByGroupId();
			/*queryWageBatchList({
				"groupId": this.formInline.payGroupId,
				"wageTemplateId": this.formInline.templateId
			}).then(res => {
				/!*if(res.msg=='success'){
					this.$message.success('提交成功');
				}else{
					this.$message.error('提交失败');
				}*!/

			})*/
		},
		watch: {
			dynamicColumn: { //深度监听，可监听到对象、数组的变化
				handler(vals, oldVal) {
					let valArr = JSON.parse(JSON.stringify(vals));
					let valArr1 = valArr.filter(val => {
						val.grounpColumns = val.grounpColumns.filter(item=>{
							 return item.checked;
						})
						return val
					})
					console.log(valArr1)
					this.tableColumn = valArr1.map(val => {
						val.children = val.grounpColumns;
						delete val.dataList;
						return val;
					})
					this.$refs.accountTable.refreshColumn();
				},
				deep: true //true 深度监听
			}
		},
		methods: {
      _getBatchInfoByGroupId(formInlineYu){
          let payGroupId,templateId,orgId;
          if(formInlineYu != null && formInlineYu != ""){
             payGroupId = formInlineYu.payGroupId;
             templateId = formInlineYu.templateId;
             orgId = formInlineYu.orgId;
             //由于仅工资条缓存跳转的原因，需要前端辅助处理，暂时注释掉
             /*if(commonConst.WAGE_PROC_SEG_ONGLY_PAY===formInlineYu.procNum){
               templateId = '111111';
             }*/
          }
        //查询薪酬组权限范围内的批次信息
        getBatchInfoByGroupId({
          groupId:payGroupId,//所选权限范围内的薪酬组id
          isPayFinish:commonConst.YES,//已经完成的
          wageTmplId:templateId,//所选模板
          //isCompute:commonConst.YES,//是否计算为是的,暂时排除仅工资条
          orgId:orgId//所选权限范围内的组织结构
        }).then(res=>{
          this.batchName = '';
          this.tableColumn=[]
          this.dynamicColumn = []
          this.radio=''
          let re = res.data
          if(re.code==0){
            this.$set(this, "batchInfoList", re.data);//更新集合
          }
        })
        //获取

      },
			save() {
        if(this.batchInfo.batchName.length==0){
          this.$message.error("请先选择需要复制的历史批次");
          return;
        }
				let tableColumn = []
				this.tableColumn.map(item => {
					item.children.map(item1 => {
						tableColumn.push({
							'field': item1.field
						})
					})
				});
				//this.dialogheaderVisible = true;
        this.$confirm('是否确认保存?','提示',{
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(()=>{
          this.loading=true;
          saveHisBatchData({
            'orgId': this.formInline.orgId,//所选机构id
            "groupId": this.formInline.payGroupId,//薪酬组id
            "batchId": this.batchInfo.id,//所选批次,需要复制的批次id
            "templateId": this.formInline.templateId,
            "regionId": this.formInline.region,
            'itemList': tableColumn,
            'wageMonth': this.batchInfoDetail.wageMonth,//工资月份
            'taxMonth': this.batchInfoDetail.taxMonth,//税金月份
            'batchName':this.batchInfoDetail.batchName,//批次名称
            'insuranceMonth': this.batchInfoDetail.socMonth//社保月份
          }).then(res => {
            this.loading=false;
            let re = res.data;
            if(re.code==0){
              let batchInfo = re.data;
              let isHistoryFlag = 'false';//查询工资
              //保存成功后跳转明细页面
              this.getDetailMessage(this.formInline,batchInfo,isHistoryFlag);
            }

          })
        });
			},
			changeIndex(i) {
				this.showIndex = i;
			},
      selectBatchInfo(id){//历史批次信息选择事件
        const templateId = this.formInline.templateId;
        console.log(this.batchInfoList);
        this.batchInfoList.forEach(item=>{
          if(item.id==id){
            this.batchInfo=item
            this.isShow = true;//显示选中的批次历史信息
         }
        });
			  //可复制的导入项，根据所选批次级联查询
        this._queryWageItems(templateId,id);
        this.$set(this,'radio',"1");
          setTimeout(()=>{
              this.changList();
          },3000)
        //查询选择历史,有配置过的加载最近配置的已选列头

      },
      //可复制的导入项，根据所选批次级联查询
      _queryWageItems(templateId,batchId){
        this.loading = true;
        queryWageItems({
          "templateId": templateId
        }).then(res => {
          let re = res.data;
					re.map(re1=>{
						re1.dataList.map(list=>{
							list.checked = true;
						})
					})
					console.log(re);
          this.$set(this, 'dynamicColumn', re)
          queryOldTemplateHeader({
            "batchId":batchId,
            "wageTemplateId":templateId
          }).then(res => {
            let re = res.data;
            if(re && re.length>0){
              let dynamicColumn = JSON.parse(JSON.stringify(this.dynamicColumn));
              dynamicColumn.map(column => {
                re.map(data => {
                  if(column.field==data.field){
                    column.grounpColumns = data.dataList;
                  }
                })
              })

							console.log(dynamicColumn,4444444444444)
              this.$set(this,'dynamicColumn',dynamicColumn);
              this.$forceUpdate();
              this.$refs.accountTable.refreshColumn();
              this.$set(this,'radio',"1");//默认触发全选

            }
            //测试处理默认已选项
            /*if(this.dynamicColumn && this.dynamicColumn.length>0){
              this.tableColumn = this.dynamicColumn.filter(val => {
                if( val.dataList.length > 0){
                  val.children = val.dataList;
                  return val;
                }
              })
              //this.$refs.accountTable.refreshColumn();
            }*/
          })
        })
      },
      getDetailMessage(formInline,batchInfo,isHistoryFlag){
        if(commonConst.NO===batchInfo.isCompute){
          let id = batchInfo.id;
          let wageTmplId = formInline.templateId;
          let query = {
            batchId: id,
            templateId:wageTmplId,
            formInline:formInline,
            batchInfoDetail:this.batchInfoDetail,
            /*serverGroupList:this.serverGroupList,
            contentServerGroup:this.contentServerGroup,*/
          }
          console.log("编辑参数query=", query);
          this.$router.push({
            path: '/payrollSettings/wageBatchInfoGroupTable',
            query
          });
        }
        if(commonConst.YES===batchInfo.isCompute){
          const query = {
            templateId: formInline.templateId,
            batchId: batchInfo.id,
            orgId: batchInfo.orgId,
            payGroupId: batchInfo.groupId,
            wageMonth: batchInfo.wageMonth,
            socMonth: batchInfo.socMonth,
            payWay: batchInfo.payWay,
            taxMonth: batchInfo.taxMonth,
            isHistoryFlag:isHistoryFlag//查询工资历史或查询工资明细，ture历史，false明细
          }
          console.log("跳转明细页携带参数=", query);
          this.$router.push({
            path: '/wage/salaryDetailTabs',
            query
          });
        }

      },
			changList() {
				if (this.radio == '1') {
					this.dynamicColumn.map((item) => {
						this.$set(item, 'grounpColumns', item.dataList)
					})
				} else {
					this.dynamicColumn.map((item) => {
						this.$set(item, 'grounpColumns', [])
					})
				}
        this.loading = false;
				this.$forceUpdate();
			}
		}
	};
</script>

<style scoped>
	.tips {
		font-size: 13px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: rgba(51, 51, 51, 1);
		line-height: 18px;
		margin-bottom: 16px;
	}

	.tips>* {
		vertical-align: middle;

	}

	.tips span {
		color: rgba(51, 51, 51, 1);
	}

	.p1 {
		font-size: 13px;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 500;
		color: rgba(51, 51, 51, 1);
		line-height: 18px;
	}

	.div1 {
		display: flex;
		justify-content: space-between;
		margin-top: 10px;
		align-items: center;
	}

	.div1>.flex {
		display: flex;
		height: 36px;
	}

	.seachBox>div {
		height: 34px;
		line-height: 34px;
		width: 45%;
		margin-bottom: 10px;
	}

	.seachBox>div span {
		vertical-align: top;
		font-size: 12px;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 500;
		color: rgba(51, 51, 51, 1);
		display: inline-block;
		width: 118px;
		text-align: justify;
		text-align-last: justify;
	}

	.seachBox {
		display: flex;
		justify-content: space-between;
		flex-wrap: wrap;

	}

	.footer {
		display: flex;
		margin-top: 16px;
	}

	.footer div {
		font-size: 13px;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 500;
		color: rgba(51, 51, 51, 1);
		line-height: 18px;
	}

	.footer p {
		font-size: 13px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: rgba(51, 51, 51, 1);
		line-height: 18px;
		margin-bottom: 12px;
		text-align: left;
	}
</style>
